module.exports = __webpack_public_path__ + "static/metrogoldwyn-5f2dbfd6c61c0ec2aee6c67d379c38d7.png";